import { CONST } from "../../../CONST";
import Distraction, { DistractionConfig, DistractionState} from "../Distraction";

const CONFIG = {
    animation: {
        movement: {
            duration: 800,
            ease: {in: "Back.easeOut", out: "Back.easeIn"},
            from: {x: 0, y: 150},
        },
    },

    hand: {
        duration: 500,
        x: 5,
        y: -50,
        angle: {from: 30, to: 15},
    }
}

export default class WindowDistraction extends Distraction {
    private container : Phaser.GameObjects.Container;
    private characterImg : Phaser.GameObjects.Image;
    private handImg : Phaser.GameObjects.Image;
    
    private moveTween !: Phaser.Tweens.Tween;
    private activeTween !: Phaser.Tweens.Tween;

    constructor(scene: Phaser.Scene, config: DistractionConfig){
        super(scene, config);

        this.container = scene.add.container(config.x + CONFIG.animation.movement.from.x, config.y + CONFIG.animation.movement.from.y)
            .setDepth(config.depth);
            
        this.characterImg = scene.add.image(-29.6, -51, CONST.DISTRACTION.WINDOW_CHARACTER);

        this.handImg = scene.add.image(CONFIG.hand.x, CONFIG.hand.y, CONST.DISTRACTION.WINDOW_HAND)
                        .setAngle(CONFIG.hand.angle.from)
                        .setOrigin(0.12,0.87);

        this.characterImg.on("pointerup", () => {
            this.handleClick();
        });

        this.container.add([this.handImg, this.characterImg]);
        this.init();

        this.animateHand();
    }

    animateMovement(rollingIn : boolean){
        this.scene.sound.play(CONST.AUDIO.HELLO, {detune: this.scene.getDetune(), volume: 2});

        if (this.moveTween){
            this.moveTween.stop();
        }

        this.container.setPosition(this.config.x + (rollingIn ? CONFIG.animation.movement.from.x : 0),
            this.config.y + (rollingIn ? CONFIG.animation.movement.from.y : 0));

        this.container.setScale(1, rollingIn ? 0.7 : 1)
        this.moveTween = this.scene.tweens.add({
            targets: this.container,
            x: this.config.x + (rollingIn ? 0 : CONFIG.animation.movement.from.x),
            y: this.config.y + (rollingIn ? 0 : CONFIG.animation.movement.from.y),
            scaleY: rollingIn ? 1 : 0.7,
            ease: rollingIn ? CONFIG.animation.movement.ease.in : CONFIG.animation.movement.ease.out,
            duration: CONFIG.animation.movement.duration,
            repeat: 0,
        });
    }

    animateHand(){
        this.scene.tweens.add({
            targets: this.handImg,
            angle: CONFIG.hand.angle.to,
            ease: "Quad.easeInOut",
            duration: CONFIG.hand.duration,
            repeat: -1,
            yoyo: true,
        });
    }

    animateActive(isActive: boolean){
        if (isActive){
            this.activeTween = this.scene.tweens.add({
                targets: this.container,
               scaleY: 1.05,
    
                ease: "Quad.easeOut",
                duration: 250,
                repeat: -1,
                yoyo: true,
            });
        } else {
            this.container.setScale(1);
            if (this.activeTween){
                this.activeTween.stop();
            }
        }
        
    }

    private handleClick(){
        this.deactivate();
    }

    onDeactivated(): void {
    }

    onStarting(): void {
        this.characterImg.setInteractive({useHandCursor: true, pixelPerfect: true, alphaTolerance: 1});

        this.animateMovement(true);
        setTimeout(() => {
            this.changeState(DistractionState.Active);
        }, CONFIG.animation.movement.duration);

    }

    onActivated(): void {
        this.animateActive(true);
    }

    onEnding(): void {

        this.characterImg.disableInteractive();

        this.animateActive(false);

        this.animateMovement(false);

        setTimeout(() => {
            this.changeState(DistractionState.Deactivated);
        }, CONFIG.animation.movement.duration);
    }

    onGameLost(): void {
        this.characterImg.disableInteractive();
    }
}